import * as React from 'react';
import { Modal, Select } from 'antd';
const { Option } = Select;
type Props = {
    themeId?: number;
    isVisible: boolean;
    hideModal: Function;
    setThemeId: Function;
    onThemeSave: Function;
}

const ThemeModal: React.FC<Props> = ({
    themeId,
    isVisible,
    hideModal,
    setThemeId,
    onThemeSave
}) => {

  let newThemeId = themeId;

  const renderHelperText = () => {
    switch (newThemeId) {
        case 1:
            return 'The light theme will persist every time you sign in. You can change this setting at any time from your user menu.'
        case 2:
            return 'The dark theme will persist every time you sign in. You can change this setting at any time from your user menu.' 
        case 0:
            return 'Your theme will be defaulted to your current browser settings every time you sign in.  Use your browser or Operating system setting configurations to change the theme. When changing your browser theme a page refresh may be required for the change to take effect.' 
      }
  }

  return(
    <Modal 
      okText="Save"
      visible={isVisible}
      onCancel={() => hideModal()}
      onOk={() => onThemeSave()}
    >
      <div className="theme-modal-text">Please select a theme to use:</div>
      <Select
        className="theme-modal-select"
        value={newThemeId}
        onChange={(val) => setThemeId(val)}
      >
        <Option value={1}>Light</Option>
        <Option value={2}>Dark</Option>
        <Option value={0}>Current Browser Setting</Option>
      </Select>
      <div className="theme-modal-text">
          {renderHelperText()}
      </div>
    </Modal>

)};

export default ThemeModal;